export const auth = {
    SET_USER_ID: 'SET_USER_ID',
    SET_PROFILE: 'SET_PROFILE',
    SET_IS_AUTHENTICATED: "SET_IS_AUTHENTICATED"
};
